export enum MessageType {
  SAVE_PORTAL_UPDATE = "SAVE_PORTAL_UPDATE",
  SAVE_NTU_PATIENT = "SAVE_NTU_PATIENT",
  ELIGIBILITY_FAILURE = "ELIGIBILITY_FAILURE",
  INFORMATION_FAILURE = "INFORMATION_FAILURE",
  DOCUMENT_UPLOADED = "DOCUMENT_UPLOADED",
  REFERRAL_CREATED = "REFERRAL_CREATED",
  REFERRAL_NOT_CREATED = "REFERRAL_NOT_CREATED",
  PRIOR_AUTH_NOT_CREATED = "PRIOR_AUTH_NOT_CREATED",
  ADDITIONAL_VISITS = "ADDITIONAL_VISITS",
  RE_AUTH_CREATED = "RE_AUTH_CREATED",
  RE_AUTH_NOT_CREATED = "RE_AUTH_NOT_CREATED",
  TRAINING_VIDEO_FAILURE = "TRAINING_VIDEO_FAILURE",
  DOCUMENT_NOT_UPLOADED = "DOCUMENT_NOT_UPLOADED",
  INGEST_FAILED = "INGEST_FAILED",
  INGEST_SUCCESS = "INGEST_SUCCESS",
  REGISTER_USER_FAILURE = "REGISTER_USER_FAILURE",
  REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS",
  FORGOT_PASS_FAILURE = "FORGOT_PASS_FAILURE",
  FORGOT_PASS_SUCCESS = "FORGOT_PASS_SUCCESS",
  RESET_PASS_FAILURE = "RESET_PASS_FAILURE",
  RESET_PASS_SUCCESS = "RESET_PASS_SUCCESS",
  UPLOAD_TRAINING_VIDEO_FAILURE = "UPLOAD_TRAINING_VIDEO_FAILURE",
  SAVE_TRAINING_VIDEO_SUCCESS = "SAVE_TRAINING_VIDEO_SUCCESS",
  UPDATE_TRAINING_VIDEO_SUCCESS = "UPDATE_TRAINING_VIDEO_SUCCESS",
  USER_DETAILS_ADDED = "USER_DETAILS_ADDED",
  USER_DETAILS_UPDATED = "USER_DETAILS_UPDATED",
  RESET_PASS_LINK_NOT_SHARED = "RESET_PASS_LINK_NOT_SHARED",
  RESET_PASS_LINK_SHARED = "RESET_PASS_LINK_SHARED",
  RESENT_REGISTRATION_LINK_SUCCESS = "RESENT_REGISTRATION_LINK_SUCCESS",
  RESENT_REGISTRATION_LINK_FAILURE = "RESENT_REGISTRATION_LINK_FAILURE",
  USER_STATUS_NOT_UPDATE = "USER_STATUS_NOT_UPDATE",
  UPLOAD_TRAINING_VIDEO_LOADING = "UPLOAD_TRAINING_VIDEO_LOADING",
  DEACTIVE_USER = "DEACTIVE_USER",
  SCORECARD_DETAILS_TECHNICAL_DIFFICULTIES_ERROR = "SCORECARD_DETAILS_TECHNICAL_DIFFICULTIES_ERROR",
  SCORECARD_DETAILS_NOT_FOUND_ERROR = "SCORECARD_DETAILS_NOT_FOUND_ERROR",
  CREATE_PATIENT_FAILURE = "CREATE_PATIENT_FAILURE",
  COMPARENPI_FAILURE = "COMPARENPI_FAILURE",
  EXCE_DOWNLOAD_FAILURE = "EXCE_DOWNLOAD_FAILURE",
  EXCEL_DOWNLOAD_NOT_FOUND = "EXCEL_DOWNLOAD_NOT_FOUND",
  USER_DETAILS_UPDATE_FAILURE = "USER_DETAILS_UPDATE_FAILURE",
  ACCESS_ADMIN_PAGE_CHANGE = "ACCESS_ADMIN_PAGE_CHANGE",
  AGENCY_UPDATE_SUCCESS = "AGENCY_UPDATE_SUCCESS",
  WARNING_CANCEL = "WARNING_CANCEL",
  WARNING_PAGE_CHANGE = "WARNING_PAGE_CHANGE",
  SWEET_ALERT_PROCESS_MESSAGE = "SWEET_ALERT_PROCESS_MESSAGE",
  REFERRAL_SUCCESS = "REFERRAL_SUCCESS",
  INGEST_PROCESS_FAILED = "INGEST_PROCESS_FAILED",
  DOCUMENT_UPLOAD_PROGRESS = "DOCUMENT_UPLOAD_PROGRESS",
  DOCUMENT_UPLOADED_SUCCESSFULLY = "DOCUMENT_UPLOADED_SUCCESSFULLY",
  DOCUMENT_DOWNLOAD_ERROR = "DOCUMENT_DOWNLOAD_ERROR",
  DOCUMENT_UPDATE_NOMNC_DETAILS_ERROR = "DOCUMENT_UPDATE_NOMNC_DETAILS_ERROR",
  FILE_UPLOADED_SUCCESSFULLY = "FILE_UPLOADED_SUCCESSFULLY",
  RELOAD_MESSAGE = "RELOAD_MESSAGE",
  UNAUTHORIZED_MESSAGE = "UNAUTHORIZED_MESSAGE",
  UNAUTHORIZED_ERROR_HEADER = "UNAUTHORIZED_ERROR_HEADER",
  NEW_VERSION_HEADER = "NEW_VERSION_HEADER",
  DEACTIVATED_SUCCESSFULLY = "DEACTIVATED_SUCCESSFULLY",
  NOTIFICATION_UPDATED_SUCCESSFULLY = "NOTIFICATION_UPDATED_SUCCESSFULLY",
  NOTIFICATION_UPLOADED_SUCCESSFULLY = "NOTIFICATION_UPLOADED_SUCCESSFULLY",
  NO_PROVIDERS_AVAILABLE_SSO_BCBS_TN_USER = "NO_PROVIDERS_AVAILABLE_SSO_BCBS_TN_USER",
  DECISION_ENGINE_MESSAGE1 = "DECISION_ENGINE_MESSAGE1",
  DECISION_ENGINE_MESSAGE2 = "DECISION_ENGINE_MESSAGE2",
  START_OF_CARE_UPDATE_FAILED = "START_OF_CARE_UPDATE_FAILED",
  START_OF_CARE_UPDATE_SUCCESS = "START_OF_CARE_UPDATE_SUCCESS"
}

export const ResponseMessages = (value: string, performancePeriod?: string) => {
  switch (value) {
    case MessageType.SAVE_PORTAL_UPDATE:
      return "Portal update saved successfully!";
    case MessageType.SAVE_NTU_PATIENT:
      return "Ntu sent!";
    case MessageType.ELIGIBILITY_FAILURE:
      return "Select valid health plan from dropdown !";
    case MessageType.INFORMATION_FAILURE:
      return "Requested information not saved, something went wrong !";
    case MessageType.DOCUMENT_UPLOADED:
      return "Document uploaded..!";
    case MessageType.DOCUMENT_NOT_UPLOADED:
      return "Document not uploaded..!";
    case MessageType.REFERRAL_CREATED:
      return "Referral Created Successfully !!";
    case MessageType.REFERRAL_NOT_CREATED:
      return "Submission failed. Please try again or submit a Freshdesk ticket if the issue persists";
    case MessageType.PRIOR_AUTH_NOT_CREATED:
      return "PriorAuthorization is failed, try again !";
    case MessageType.RE_AUTH_CREATED:
      return "Confirmation Number";
    case MessageType.RE_AUTH_NOT_CREATED:
      return "ReAuthorization is failed, try again !";
    case MessageType.ADDITIONAL_VISITS:
      return "Please add a visit for any of the discipline.";
    case MessageType.TRAINING_VIDEO_FAILURE:
      return "Video is not available, contact tango admin !";
    case MessageType.REGISTER_USER_SUCCESS:
      return "User register successfully !";
    case MessageType.INGEST_FAILED:
      return "Ingest Process Failed!";
    case MessageType.INGEST_SUCCESS:
      return "Ingest Uid";
    case MessageType.REGISTER_USER_FAILURE:
      return "User registration failed !";
    case MessageType.FORGOT_PASS_FAILURE:
      return "Reset Password Link was not sent on provided email !";
    case MessageType.FORGOT_PASS_SUCCESS:
      return "Reset Password Link is sent successfully on provided email !";
    case MessageType.RESET_PASS_FAILURE:
      return "Password not reset !";
    case MessageType.RESET_PASS_SUCCESS:
      return "Password reset successfully !";
    case MessageType.USER_DETAILS_UPDATED:
      return "User details updated successfully!";
    case MessageType.RESET_PASS_LINK_NOT_SHARED:
      return "Reset password link not shared..!";
    case MessageType.RESET_PASS_LINK_SHARED:
      return "Reset Password link shared on mail successfully..!";
    case MessageType.RESENT_REGISTRATION_LINK_SUCCESS:
      return "Resend Registration link shared on mail successfully..!";
    case MessageType.RESENT_REGISTRATION_LINK_FAILURE:
      return "Resend Registration link not shared..!";
    case MessageType.USER_STATUS_NOT_UPDATE:
      return "User Status Not Updated..!";
    case MessageType.UPLOAD_TRAINING_VIDEO_FAILURE:
      return "Training video upload failed!";
    case MessageType.SAVE_TRAINING_VIDEO_SUCCESS:
      return "Training video successfully uploaded!";
    case MessageType.UPDATE_TRAINING_VIDEO_SUCCESS:
      return "Training video successfully updated!";
    case MessageType.USER_DETAILS_ADDED:
      return "New User added successfully, Registration link sent on provided email.";
    case MessageType.UPLOAD_TRAINING_VIDEO_LOADING:
      return "Video upload is in progress!";
    case MessageType.DEACTIVE_USER:
      return "User ID is disabled. Please contact the Administrator for assistance.";
    case MessageType.SCORECARD_DETAILS_TECHNICAL_DIFFICULTIES_ERROR:
      return "We are currently experiencing technical difficulties. Please check back later.";
    case MessageType.SCORECARD_DETAILS_NOT_FOUND_ERROR:
      return `Unable to display chosen scorecard for ${performancePeriod}. Click out of window and toggle performance period for specific scores.`
    case MessageType.CREATE_PATIENT_FAILURE:
      return "Create patient failed.";
    case MessageType.COMPARENPI_FAILURE:
      return "No data found to show compare NPI graph !";
    case MessageType.EXCE_DOWNLOAD_FAILURE:
      return "Excel download failed!";
    case MessageType.EXCEL_DOWNLOAD_NOT_FOUND:
      return "Document not found!";
    case MessageType.USER_DETAILS_UPDATE_FAILURE:
      return "User Not Updated!"
    case MessageType.ACCESS_ADMIN_PAGE_CHANGE:
      return "Save existing changes on this page"
    case MessageType.AGENCY_UPDATE_SUCCESS:
      return "Agency access updated successfully!!"
    case MessageType.WARNING_CANCEL:
      return "Are you sure you want to cancel without saving any changes?"
    case MessageType.WARNING_PAGE_CHANGE:
      return "Are you sure to change the page without saving any changes?"
    case MessageType.REFERRAL_SUCCESS:
      return "Confirmation Number"
    case MessageType.INGEST_PROCESS_FAILED:
      return "No response from server, ingest process has been failed";
    case MessageType.SWEET_ALERT_PROCESS_MESSAGE:
      return "Processing request. Please do not leave or refresh this page until the process is complete.";
    case MessageType.DOCUMENT_UPLOAD_PROGRESS:
      return "Document upload is in progress"
    case MessageType.DOCUMENT_UPLOADED_SUCCESSFULLY:
      return "Documents successfully uploaded."
    case MessageType.DOCUMENT_DOWNLOAD_ERROR:
      return "Document Download Error!";
    case MessageType.DOCUMENT_UPDATE_NOMNC_DETAILS_ERROR:
      return "Failed to update NoMNC Document details.";
    case MessageType.FILE_UPLOADED_SUCCESSFULLY:
      return "File uploaded successfully.";
    case MessageType.RELOAD_MESSAGE:
      return "Please reload to continue with the latest version.";
    case MessageType.UNAUTHORIZED_MESSAGE:
      return "Your session has expired. Please log in again.";
    case MessageType.UNAUTHORIZED_ERROR_HEADER:
      return "Unauthorized Access";
    case MessageType.NEW_VERSION_HEADER:
      return "New Version Available";
    case MessageType.DEACTIVATED_SUCCESSFULLY:
      return "Notification deactivated successfully."
    case MessageType.NO_PROVIDERS_AVAILABLE_SSO_BCBS_TN_USER:
      return `The NPI that you have used to sign-in is not registered in the tango system. Please contact tango's provider relations team @ providerrelations@tangocare.com`;
    case MessageType.NOTIFICATION_UPDATED_SUCCESSFULLY: 
      return "Notification updated successfully."
    case MessageType.NOTIFICATION_UPLOADED_SUCCESSFULLY:
      return "Notification uploaded successfully."
    case MessageType.DECISION_ENGINE_MESSAGE1:
      return "You may click the link below to view results and download your authorization notification.";
    case MessageType.DECISION_ENGINE_MESSAGE2:
      return "The decision will also be available in the member's authorization on the portal home page.";
    case MessageType.START_OF_CARE_UPDATE_FAILED:
      return "Failed to update Start of Care date.";
    case MessageType.START_OF_CARE_UPDATE_SUCCESS:
      return "Start of Care date updated successfully.";
    default:
      return "";
  }
};

export const NO_OPTIONS = "No options";
export const RETRO_MODAL = "Please enter at least 1 visit for selected discipline.";